module.exports = __webpack_public_path__ + "img/home-4-mobilepeople.79e2fc94.png";